import { call, fork, put, takeLatest } from "redux-saga/effects";
import {
  activateUserSuccess,
  activateUserError,
  Types
} from "../../actions/user/activateUser.actions";

import * as api from "../../api/user.api";

function* activateUser({ payload }) {
  try {
    yield call(api.activateUser, payload.token);
    yield put(activateUserSuccess());
  } catch (err) {
    const errorMessage =
      err &&
      err.response &&
      err.response.data &&
      err.response.data.Messages
        ? err.response.data.Messages
        : "Activation failed.";

    yield put(activateUserError(errorMessage));
  }
}

function* watchActivateUser() {
  yield takeLatest(Types.ACTIVATE_USER, activateUser);
}

export default [fork(watchActivateUser)];
